import { FC, useContext } from 'react';
import { ParagraphFarmTeaserListFragment } from '../../../generated/types';
import { Box, VStack } from '@chakra-ui/react';
import { PageContext } from '../../../context/PageContext';
import { FarmTeaser } from '../../Teaser/FarmTeaser';

interface FarmTeaserListProps {
  data: ParagraphFarmTeaserListFragment;
}

export const FarmTeaserList: FC<FarmTeaserListProps> = ({ data }) => {
  const pageContext = useContext(PageContext);

  return (
    <VStack spacing={9}>
      {data.teasers
        .filter((teaser) => teaser.id !== pageContext?.entity?.id)
        .map((teaser, i) => (
          <Box key={i}>
            <FarmTeaser data={teaser} />
          </Box>
        ))}
    </VStack>
  );
};
